import type { SceneId } from '../mapping/types';
import { createArpScene } from './arp';
import { createBassScene } from './bass';
import { createBreaksScene } from './breaks';
import { createScratchScene } from './scratch';
import { createTalaScene } from './tala';
import { createWarbleScene } from './warble';
import type { Scene } from './types';

export const SCENE_ORDER: SceneId[] = ['bass', 'arp', 'breaks', 'scratch', 'tala', 'warble'];

export const SCENE_FACTORIES: Record<SceneId, () => Scene> = {
  bass: createBassScene,
  arp: createArpScene,
  breaks: createBreaksScene,
  scratch: createScratchScene,
  tala: createTalaScene,
  warble: createWarbleScene,
};

export const SCENE_LABELS: Record<SceneId, string> = {
  bass: 'Bass', arp: 'Arp', breaks: 'Amen', scratch: 'Scratch', tala: 'Tala', warble: 'Warble',
};

export type { Scene, SceneContext } from './types';
